module.exports = __webpack_public_path__ + "img/1_011.718b3f78.jpg";